import { render, staticRenderFns } from "./accidentEntry.vue?vue&type=template&id=3fa42d76&scoped=true&"
import script from "./accidentEntry.vue?vue&type=script&lang=js&"
export * from "./accidentEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa42d76",
  null
  
)

export default component.exports